<template>
    <v-app>
        <router-view/>
        <messages />
    </v-app>
</template>


<script>
    import messages from './views/components/messages'
    export default{
        name: 'App',
        components: {
            messages
        }
    }
</script>